import { render, staticRenderFns } from "./pages14.vue?vue&type=template&id=674615c0&scoped=true&"
import script from "./pages14.vue?vue&type=script&lang=js&"
export * from "./pages14.vue?vue&type=script&lang=js&"
import style0 from "./pages14.vue?vue&type=style&index=0&id=674615c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674615c0",
  null
  
)

export default component.exports